// navigator.share e navigator.canShare so existem em CONTEXTO SEGURO. Servido
// por http:// num IP da rede -- que era como o app chegava ao celular dela antes
// da hospedagem -- eles nao existem. Medido em 2026-08-05, mesmo servidor e
// mesmo codigo:
//   http://192.168.15.5:5173 -> share undefined
//   http://localhost:5173    -> share function
//
// ⚠ Ate 2026-08-07 este arquivo BAIXAVA sozinho quando isso acontecia, e quem
// chamava tratava "baixou" como "enviou". Baixar nao e enviar: agora ele diz
// 'indisponivel' e quem chama decide o que oferecer.
export function explicacaoSemCompartilhamento(contextoSeguro: boolean): string {
  const base =
    'Este navegador não abre o compartilhamento. O arquivo não foi baixado — escolha abaixo o que fazer.'
  if (contextoSeguro) return base
  return `${base} O app está aberto por http://; compartilhar só funciona em https.`
}

export type ResultadoCompartilhar = 'compartilhado' | 'cancelado' | 'indisponivel'

export async function compartilharArquivo(
  blob: Blob,
  nomeArquivo: string,
): Promise<ResultadoCompartilhar> {
  const arquivo = new File([blob], nomeArquivo, { type: 'application/pdf' })
  const navegador = navigator as Navigator & {
    canShare?: (dados: { files: File[] }) => boolean
  }
  if (!navegador.canShare?.({ files: [arquivo] })) return 'indisponivel'
  try {
    await navigator.share({ files: [arquivo], title: nomeArquivo })
    return 'compartilhado'
  } catch (erro) {
    // Só AbortError e a pessoa desistindo. Qualquer outra falha e o navegador
    // nao dando conta -- e isso e 'indisponivel', nao "ela cancelou".
    if (erro instanceof DOMException && erro.name === 'AbortError') return 'cancelado'
    return 'indisponivel'
  }
}

// O download EXPLICITO, so quando ela pede. Nao muda status de nada.
export function baixarArquivo(blob: Blob, nomeArquivo: string): void {
  const url = URL.createObjectURL(blob)
  const ancora = document.createElement('a')
  ancora.href = url
  ancora.download = nomeArquivo
  ancora.click()
  URL.revokeObjectURL(url)
}

// O TEXTO do produto (botao Compartilhar da ficha, 23/09). Mesmo contrato do
// arquivo: 'indisponivel' nunca finge que enviou -- quem chama oferece o link
// do WhatsApp, que funciona ate em http://.
export async function compartilharTexto(texto: string): Promise<ResultadoCompartilhar> {
  const navegador = navigator as Navigator & { share?: (dados: { text: string }) => Promise<void> }
  if (typeof navegador.share !== 'function') return 'indisponivel'
  try {
    await navegador.share({ text: texto })
    return 'compartilhado'
  } catch (erro) {
    if (erro instanceof DOMException && erro.name === 'AbortError') return 'cancelado'
    return 'indisponivel'
  }
}

// Sem numero de proposito: o WhatsApp abre e pergunta para quem mandar.
export function linkDoWhatsApp(texto: string): string {
  return `https://wa.me/?text=${encodeURIComponent(texto)}`
}
